import styled, { css } from 'styled-components';
import { variant, gridGap, GridProps } from 'styled-system';

import { ThemeUtilities } from '../../../theme';

import { Size, Variant, ContentSizeWithAddress, Status } from './types';

export const Card = styled.div<{
  cardSize: Size;
  variant: Variant;
  status?: Status;
}>`
  display: inline-flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  overflow: hidden;
  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'BankAccount', 'cardSize')
    )};

  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'BankAccount', 'variant')
    )};

  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'BankAccount', 'status')
    )};
`;

export const WatermarkContainer = styled.div<{ size: Size }>`
  position: absolute;
  right: 0;
  top: 50%;
  z-index: -1;
  transform: translateY(-50%);
  transform-origin: 100% 0;

  ${({ size }) =>
    size === 'small' &&
    css`
      transform: scale(0.68) translateY(-50%);
    `};
`;

export const NumbersContainer = styled.div<GridProps>`
  display: flex;
  ${gridGap};
`;

export const Number = styled.div`
  flex: 1;
  min-width: 0;
`;

export const AddressContainer = styled.div<{ addressSize: Size }>`
  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'BankAccount', 'addressSize')
    )};
`;

export const Content = styled.div<{ contentSize: ContentSizeWithAddress }>`
  flex: 1;
  display: flex;
  flex-direction: column;

  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'BankAccount', 'contentSize')
    )};
`;

export const Row = styled.div<GridProps>`
  display: flex;
  align-items: center;

  ${gridGap};
`;
